import { useState, useEffect } from "react";
import { pnpLogo } from "../../../Asserts";
import useDeviceType from "../../../Utiles/FindDevice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { loginValidationSchema } from "../../../../vallidation/loginSchema";
import useFormikValidation from "../../../Validation/useFormikValidation";
import { toast } from "react-toastify";
import axios from "axios";
import QRCode from "../../../Asserts/images/qr_code.png";
import { baseURL } from "../../../services/axiosConfig";
import { tokenUpdate, initialToken } from "../../RoundToJoin/tocken.slice";
import Button from "../../../Components/Auth/Button";
import {
  FooterTab,
  MobileFooter,
} from "../../../../Components/GreenHome/Footer";
import { updateSession } from "../../Dashboard/dashboard.slice";

const LoginPage = () => {
  const deviceType = useDeviceType();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const storedEmail = localStorage.getItem("e");

  const [emailFocused, setEmailFocused] = useState(false);
  const [passwordFocused, setPasswordFocused] = useState(false);
  const [rememberMe, setRememberMe] = useState(
    localStorage.getItem("rememberMe") === "true" ? true : false
  );

  const userInfoError = useSelector((state) => {
    return state?.user?.error;
  });

  useEffect(() => {
    checkExistingSession();
  }, []);

  const checkExistingSession = async () => {
    try {
      const accessToken = JSON.parse(localStorage.getItem("access_token"));
      const refreshToken = JSON.parse(localStorage.getItem("refresh"));
      const isRemembered = localStorage.getItem("rememberMe") === "true";

      if (accessToken && refreshToken && isRemembered) {
        const isValidToken = await verifyToken(accessToken);

        if (isValidToken) {
          await getUserProfile(accessToken);
          return;
        } else {
          const newTokens = await refreshAccessToken(refreshToken);
          if (newTokens) {
            await getUserProfile(newTokens.access);
            return;
          }
        }
      }

      if (!isRemembered) {
        clearAuthData();
      }
    } catch (error) {
      clearAuthData();
    }
  };

  const verifyToken = async (token) => {
    try {
      await axios.get(`${baseURL}/api/accounts/user/me`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return true;
    } catch (error) {
      return false;
    }
  };

  const refreshAccessToken = async (refreshToken) => {
    try {
      const response = await axios.post(`${baseURL}/accounts/token/refresh/`, {
        refresh: refreshToken,
      });

      const newAccessToken = response.data.access;

      localStorage.setItem("access_token", JSON.stringify(newAccessToken));

      return {
        access: newAccessToken,
        refresh: refreshToken,
      };
    } catch (error) {
      clearAuthData();
      return null;
    }
  };

  const getUserProfile = async (accessToken) => {
    try {
      const profileRes = await axios.get(`${baseURL}/accounts/user/me`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      dispatch(initialToken(profileRes?.data?.available_tokens));

      const isAdmin = localStorage.getItem("isAdminUser") === "true";

      if (!isAdmin) {
        toast.dismiss();
        dispatch(updateSession(false));
        navigate("/dashboard");
      }
    } catch (error) {
      clearAuthData();
    }
  };

  const clearAuthData = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh");
    localStorage.removeItem("isAuthUser");
    localStorage.removeItem("isAdminUser");
    localStorage.removeItem("userInfo");
    localStorage.removeItem("rememberMe");
    localStorage.removeItem("registerEmail");
  };

  const storeAuthData = (responseData, userInfo, shouldRemember) => {
    const storage = localStorage;

    storage.setItem("access_token", JSON.stringify(responseData.access));
    storage.setItem("refresh", JSON.stringify(responseData.refresh));
    storage.setItem(
      "isAuthUser",
      JSON.stringify(responseData.access) ? true : false
    );
    storage.setItem("isAdminUser", responseData.isAdmin);
    storage.setItem("userInfo", JSON.stringify(userInfo));

    if (shouldRemember) {
      storage.setItem("rememberMe", "true");
    } else {
      storage.removeItem("rememberMe");
    }
  };

  const getUserTimezone = () => {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  };

  const handleLogin = async (values) => {
    const { email, password } = values;

    let trimValues = {
      email: email.trim().toLowerCase(),
      password: password.trim(),
      timezone: getUserTimezone(),
    };

    if (email && password) {
      try {
        formik.setSubmitting(true);
        const res = await axios.post(`${baseURL}/accounts/token/`, trimValues);

        const userInfo = {
          email: values?.email,
          isAdmin: res?.data?.isAdmin,
          userName: res?.data?.username,
          userId: res?.data?.user_uuid,
          userLogedIn: true,
        };
        if (typeof window !== "undefined" && window.dataLayer) {
          const {
            user_uuid,
            firstname,
            lastname,
            username,
            phone,
            dob,
            addressline1,
            addressline2,
            city,
            region,
            email,
            country,
            nationality,
            gender,
          } = res?.data || {};

          window.dataLayer.push({
            event: 'login',
            userId: user_uuid,
            loginMethod: 'email',
            firstName: firstname,
            lastName: lastname,
            displayName: username,
            emailAddress: email,
            phoneNumber: phone,
            dateOfBirth: dob,
            addressLine1: addressline1,
            addressLine2: addressline2,
            cityTown: city,
            region,
            country,
            nationality,
            gender: gender ? gender : null,
          });
        }
        if (rememberMe) {
          localStorage.setItem("e", btoa(values?.email));
        } else {
          localStorage.removeItem("e");
        }

        storeAuthData(res.data, userInfo, rememberMe);

        if (
          res?.data?.is_verified === false &&
          res?.data?.detail !== "No active account found"
        ) {
          toast.dismiss();
          localStorage.setItem("registerEmail", trimValues.email);
          localStorage.removeItem("countdownEndTime");
          navigate(`/emailVerification/${trimValues.email}`);
        } else {
          const profileRes = await axios.get(`${baseURL}/accounts/user/me`, {
            headers: {
              Authorization: `Bearer ${res?.data?.access}`,
            },
          });

          dispatch(initialToken(profileRes?.data?.available_tokens));

          if (res?.data?.username && !res?.data?.isAdmin) {
            toast.dismiss();
            dispatch(updateSession(false));
            navigate("/dashboard");
          }
        }
        formik.setSubmitting(false);
      } catch (error) {
        formik.setSubmitting(false);
        if (error?.response?.status === 400) {
          if (
            error?.response?.data?.non_field_errors?.[0]
              ?.toLowerCase()
              .includes("unable to log in") ||
            error?.response?.data?.non_field_errors?.[0]
              ?.toLowerCase()
              .includes("invalid credentials")
          ) {
            toast.error(
              "The password you entered is incorrect. Please try again."
            );
          } else {
            toast.error(
              error?.response?.data?.non_field_errors?.[0] ||
                "Invalid login attempt."
            );
          }
          return;
        }
        if (
          error?.response?.status === 404 ||
          error?.response?.data?.detail
            ?.toLowerCase()
            .includes("no active account found")
        ) {
          toast.error("No account exists with this email address.");
          return;
        }
        toast.error("An error occurred. Please try again.");
        console.error("Login error:", error);
      }
    }
  };

  const formik = useFormikValidation(
    {
      email: storedEmail ? atob(storedEmail) : "",
      password: "",
    },
    loginValidationSchema,
    handleLogin
  );

  const handleFieldChange = () => {
    // dispatch(fetchUserFailure(""));
  };

  const [showPassword, setShowPassword] = useState(true);

  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };

  const handleRememberMeChange = (e) => {
    setRememberMe(e.target.checked);
  };

  return (
    <>
      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(-4px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-8px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fadeIn {
          animation: fadeIn 0.2s ease-out;
        }
        .animate-slideDown {
          animation: slideDown 0.3s ease-out;
        }
      `}</style>
      <div
        style={{
          backgroundImage: `url('/v2/images/bg/${
            deviceType === "mobile" ? "auth-bg-mobile.png" : "auth-bg.png"
          }')`,
        }}
        className="bg-cover bg-no-repeat bg-center min-h-screen overflow-hidden flex flex-col justify-between"
      >
        <div
          className={`flex ${
            deviceType === "mobile"
              ? "flex-col py-16"
              : deviceType === "laptop"
              ? "lg:flex-row justify-between px-24 py-[16px]"
              : "lg:flex-row justify-between px-24 py-[56px] md:py-[24px] lg:py-[24px] 2xl:py-[60px]"
            } bg-cover bg-no-repeat bg-center items-center`}
        >
          {deviceType !== "mobile" && (
            <div className={`text-white flex flex-col justify-between min-h-[calc(100vh-152px)] ${deviceType === "desktop" ? "flex flex-col justify-between min-h-[calc(100vh-152px)]"
              : deviceType === "laptop" || deviceType === "laptop-l" || deviceType === 'laptop-l-min' ? "flex flex-col justify-between min-h-[calc(100vh-80px)]" : ""}`}>


              <a href="/">
                <img
                  src={pnpLogo}
                  alt="Logo"
                  className="h-28 md:h-24 lg:h-44 mb-6 md:-my-6 lg:-my-8"
                />
              </a>
              <div
                className={`mb-2 flex flex-col ${
                  deviceType === "laptop" || deviceType === "desktop"
                    ? "mt-auto"
                    : "md:mt-48 lg:mt-48 xl:mt-56 2xl:mt-64"
                }`}
              >
                <img src={QRCode} alt="QR Code" className="h-28 w-28 mb-4" />
                <p className="text-lg">
                  Scan this code to
                  <br />
                  switch devices
                </p>
              </div>
            </div>
          )}

          <div
            className={`flex flex-col  ${deviceType === "mobile" ? "w-full px-6" : deviceType === "laptop" || deviceType === "laptop-xl" ? "mt-[3%]" : "h-full "
              } items-center justify-center`}
          >
            {deviceType === "mobile" && (
              <a href="/">
                <img src={pnpLogo} alt="Login" className="h-32" />
              </a>
            )}
            <div
              className={`bg-white rounded-b-[12px] rounded-t-[6.5px] ${
                deviceType === "mobile"
                  ? "w-[100%] mx-auto my-8"
                  : deviceType === "tablet"
                  ? "w-[400px] h-[450px] max-w-[500px]"
                  : deviceType === "laptop"
                  ? "w-[400px] max-w-[500px] h-[450px]"
                  : "w-[450px] max-w-[500px] lg:h-[480px] 2xl:h-full"
              }`}
            >
              <div
                className={`bg-gradient-to-r h-[6px] rounded-t-[12px] from-[#00C05B] to-[#007FFF] w-full`}
              ></div>
              <div className="flex justify-center items-center h-full">
                <div className="w-full">
                  <div
                    className={`${
                      deviceType === "mobile"
                        ? "px-6 py-8"
                        : deviceType === "tablet"
                        ? "px-12 py-12"
                        : deviceType === "laptop"
                        ? "px-10 py-8"
                        : "px-10 py-12"
                    }`}
                  >
                    <h2
                      className={`font-bold text-[#0081F8] font-archivo ${
                        deviceType === "mobile"
                          ? "text-[24px] mb-1"
                          : "text-[32px] mb-2"
                      }`}
                    >
                      Welcome Back
                    </h2>
                    <p
                      className={`text-gray-600 ${
                        deviceType === "mobile"
                          ? "text-[14px] mb-4"
                          : deviceType === "laptop"
                          ? "text-[18px] mb-4"
                          : "text-[18px] mb-8"
                      }`}
                    >
                      Please enter your login details
                    </p>

                    <form
                      onSubmit={formik.handleSubmit}
                      noValidate
                      className="space-y-2"
                    >
                      <div className="space-y-1">
                        <input
                          type="email"
                          name="email"
                          placeholder="Email"
                          value={formik.values.email}
                          onChange={(e) => {
                            formik.handleChange(e);
                            handleFieldChange();
                          }}
                          onBlur={formik.handleBlur}
                          onFocus={() => setEmailFocused(true)}
                          className={`w-full border placeholder-gray-500 rounded-full focus:outline-none focus:border-[#0081F8] ${
                            deviceType === "mobile"
                              ? "px-4 py-3 text-[14px]"
                              : "px-6 py-4 text-[16px]"
                          } ${
                            formik.touched.email && formik.errors.email
                              ? "border-red-500"
                              : "border-gray-300"
                          }`}
                          data-testid="email-input"
                        />
                        <div
                          className={
                            deviceType === "mobile" ? "h-2 ml-3" : "h-4 ml-4"
                          }
                        >
                          {formik.touched.email && formik.errors.email && (
                            <p className="text-red-500 text-xs leading-tight animate-fadeIn">
                              {formik.errors.email}
                            </p>
                          )}
                        </div>
                      </div>

                      <div className="space-y-1">
                        <div className="relative">
                          <input
                            type={showPassword ? "password" : "text"}
                            name="password"
                            placeholder="Password"
                            value={formik.values.password}
                            onChange={(e) => {
                              formik.handleChange(e);
                              handleFieldChange();
                            }}
                            onBlur={formik.handleBlur}
                            onFocus={() => setPasswordFocused(true)}
                            className={`w-full border placeholder-gray-500 rounded-full focus:outline-none focus:border-[#0081F8] ${
                              deviceType === "mobile"
                                ? "px-4 py-3 pr-10 text-[14px]"
                                : "px-6 py-4 pr-12 text-[16px]"
                            } ${
                              formik.touched.password && formik.errors.password
                                ? "border-red-500"
                                : "border-gray-300"
                            }`}
                            data-testid="password-input"
                          />
                          <button
                            type="button"
                            onClick={togglePasswordVisibility}
                            className={`absolute top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 ${
                              deviceType === "mobile" ? "right-3" : "right-4"
                            }`}
                            data-testid="toggle-password"
                          >
                            {showPassword ? (
                              <svg
                                width={deviceType === "mobile" ? "18" : "20"}
                                height={deviceType === "mobile" ? "18" : "20"}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
                                  fill="currentColor"
                                />
                              </svg>
                            ) : (
                              <svg
                                width={deviceType === "mobile" ? "18" : "20"}
                                height={deviceType === "mobile" ? "18" : "20"}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
                                  fill="currentColor"
                                />
                              </svg>
                            )}
                          </button>
                        </div>
                        <div
                          className={
                            deviceType === "mobile" ? "h-2 ml-3" : "h-4 ml-4"
                          }
                        >
                          {formik.touched.password &&
                            formik.errors.password && (
                              <p className="text-red-500 text-xs leading-tight animate-fadeIn">
                                {formik.errors.password}
                              </p>
                            )}
                        </div>
                      </div>

                      <div
                        className={`transition-all duration-300 ${
                          userInfoError
                            ? "h-auto opacity-100"
                            : "h-0 opacity-0 overflow-hidden"
                        }`}
                      >
                        {userInfoError && (
                          <div className="text-red-500 text-sm text-center bg-red-50 p-3 rounded-lg animate-slideDown">
                            {userInfoError}
                          </div>
                        )}
                      </div>

                      <div
                        className={`flex items-center text-gray-600 ${
                          deviceType === "mobile"
                            ? "mt-2 mb-3"
                            : deviceType === "laptop"
                            ? "mt-2 mb-4"
                            : "mt-4 mb-6"
                        }`}
                      >
                        <label
                          className={`flex items-center cursor-pointer ${
                            deviceType === "mobile"
                              ? "gap-2 text-[13px]"
                              : "gap-3 text-[16px]"
                          }`}
                        >
                          <input
                            type="checkbox"
                            className={`accent-[#0081F8] cursor-pointer ${
                              deviceType === "mobile" ? "w-3 h-3" : "w-4 h-4"
                            }`}
                            data-testid="remember-me"
                            checked={rememberMe}
                            onChange={handleRememberMeChange}
                          />
                          Remember me
                        </label>
                      </div>

                      <div
                        className={`flex items-center ${
                          deviceType === "mobile"
                            ? "justify-between gap-4"
                            : "justify-between"
                        }`}
                      >
                        <Button
                          type="submit"
                          text="Login"
                          onClick={formik.handleSubmit}
                          disabled={!formik.isValid}
                          loading={formik.isSubmitting}
                          data-testid="login-button"
                        />
                        <a
                          href="/forgotPassword"
                          className={`text-[#0081F8] font-inter hover:underline ${
                            deviceType === "mobile"
                              ? "text-[13px] flex-shrink-0"
                              : "text-[16px]"
                          }`}
                          data-testid="forgot-password-link"
                        >
                          Forgot Password?
                        </a>
                      </div>
                    </form>
                    <p
                      className={`text-center ${
                        deviceType === "mobile"
                          ? "text-[12px] mt-3"
                          : deviceType === "desktop"
                          ? "text-[16px] mt-8"
                          : deviceType === "laptop"
                          ? "text-[16px] mt-4"
                          : "mt-4"
                      } text-[#000000B2]`}
                    >
                      Don't have an account?{" "}
                      <a
                        href="/signup"
                        className="text-green-600 underline font-semibold hover:underline"
                      >
                        Sign up
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {deviceType === "mobile" ? (
          <MobileFooter />
        ) : (
          <FooterTab component="privacyPolicy" className="mt-auto" />
        )}
      </div>
    </>
  );
};

export default LoginPage;